<template>
  <div>
    <b-sidebar
      id="targetSidebar"
      sidebar-class="border-right"
      no-header
      :visible="showSideBar"
      @change="changeSidebar"
    >
      <!-- <div class="px-3 py-2"> -->
      <div class="sidebarContent">
        <b-card-group deck>
          <b-card
            :title="d.name"
            :img-src="d.imageUrl"
            img-top
            v-for="(d, key) in myDevices"
            :key="key"
            @click="changeDevice(d)"
            :class="{ selected: device.type === d.type }"
          >
            <b-button @click.stop="deleteDevice(d)"
              ><i class="fas fa-minus-square"></i
            ></b-button>
          </b-card>
          <b-card @click="addDevice">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            <b-card-text>
              {{ $t('Add') }}
            </b-card-text>
          </b-card>
        </b-card-group>
        <b-card
          :title="projectName"
          :img-src="getImage(project)"
          img-top
          @click="projectInfo"
          :class="{ isSample: project.type === 'sample' }"
        >
          <div class="projectInfo">
            <span>{{ projectType }}</span>
            <span v-if="project.type === 'sample'">
              , {{ getSampleTitle }}
            </span>
          </div>
        </b-card>
      </div>
    </b-sidebar>
    <b-button
      class="sidebarOpen"
      v-show="!showSideBar"
      @click="changeSidebar(true)"
    >
      <span>
        <i class="fas fa-chevron-circle-right"></i>
      </span>
    </b-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import util from '@/libs/util'
import storage from '@/libs/storage'
import { project as projectController } from '@/controller'

export default {
  name: 'SideBar',
  data() {
    return {
      selectedDevice: {}
    }
  },
  computed: {
    ...mapState([
      'showSideBar',
      'devices',
      'myDevices',
      'device',
      'tabs',
      'project',
      'language',
      'isModified'
    ]),
    projectName() {
      const projectName = util.getProjectName(this.project, this.language)
      return projectName
    },
    projectType() {
      if (this.project.type === 'sample') return this.$t('Sample Project')
      else return this.$t('My Project')
    },
    deviceType() {
      const tab = _.find(this.tabs, { id: this.project.tab })
      const device = _.find(this.devices, { type: _.get(tab, 'type') })
      return _.get(device, 'name')
    },
    getSampleTitle() {
      const tab = _.find(this.tabs, { id: this.project.tab })
      const tabName =
        this.language === 'ko' ? _.get(tab, 'nameKo') : _.get(tab, 'nameEn')
      return `${tabName} ${this.$t('Sample')}`
    }
  },
  methods: {
    ...mapMutations([
      'setShowSideBar',
      'setDevice',
      'setFilteredTabs',
      'setProjectDetailPopupData',
      'setAddDevicePopupData',
      'setMyDevices',
      'setConfirmPopupData'
    ]),
    changeSidebar(isShow) {
      if (isShow !== this.showSideBar) {
        storage.session.setItem('showSideBar', isShow)
        this.setShowSideBar(isShow)
      }
    },
    changeDevice(device) {
      this.selectedDevice = device
      if (this.isModified) {
        this.setConfirmPopupData({
          title: this.$t('Change Alert'),
          message: this.$t('Changes may not be saved.'),
          confirmHandler: this.changeDeviceHandler,
          isShow: true
        })
      } else this.changeDeviceHandler()
    },
    async changeDeviceHandler() {
      this.setConfirmPopupData({
        isShow: false
      })
      await projectController.removeCurrent(this)
      const type = this.selectedDevice.type
      const device = _.find(this.devices, { type })
      storage.session.setItem('device', device.type)
      log(device)
      this.setDevice(device)
    },
    deleteDevice(device) {
      this.selectedDevice = device
      this.setConfirmPopupData({
        title: this.$t('Delete Device'),
        message: this.$t('Are you sure to delete the device?'),
        confirmHandler: this.deleteHandler,
        isShow: true
      })
    },
    deleteHandler() {
      this.setConfirmPopupData({
        isShow: false
      })
      const devices = _.differenceBy(
        this.myDevices,
        [this.selectedDevice],
        'type'
      )
      log('deleteHandler()')
      storage.session.removeItem('device')
      this.setMyDevices(devices)
      storage.local.setItem('my_devices', JSON.stringify(devices))
      this.setDevice({})
    },
    getFilteredTabs(device) {
      const filteredTabs = _.filter(
        this.tabs,
        (tab) =>
          _.indexOf(_.union(device.availableType, [device.type]), tab.type) >= 0
      )
      log(filteredTabs)
      this.setFilteredTabs(filteredTabs)
    },
    getImage(project) {
      const tab = _.find(this.filteredTabs, { type: _.get(project, 'tab') })
      const device = _.find(this.devices, { type: _.get(tab, 'type') })
      return project.image
        ? project.image
        : device
        ? device.imageUrl
        : undefined
    },
    projectInfo() {
      if (this.project.type === 'sample')
        this.setProjectDetailPopupData({
          isShow: true
        })
    },
    addDevice() {
      this.setAddDevicePopupData({
        isShow: true
      })
    }
  },
  watch: {
    device(newVal) {
      this.getFilteredTabs(newVal)
    },
    tabs() {
      this.getFilteredTabs(this.device)
    }
  }
}
</script>

<style>
#app .b-sidebar-outer {
  z-index: 99;
}

#targetSidebar {
  margin-top: 56px;
  height: calc(100% - 56px);
  width: 275px;
}

.sidebarContent {
  padding: 10px;
}

#targetSidebar .card-deck {
  border: solid 1px black;
  margin: 0;
  margin-bottom: 15px;
  border-radius: 10px;
  border: solid 1px lightblue;
  background-color: white;
  padding: 5px;
}

#targetSidebar .card-deck .card {
  min-width: 70px;
  max-width: 70px;
  cursor: pointer;
  margin: 5px;
}

#targetSidebar .card-deck .card:hover,
#targetSidebar .card-deck .card.selected:hover {
  border: solid 1px #8585eb;
  outline: 1px solid #5757c7;
  outline-offset: -2px;
  /* opacity: 0.5; */
}

#targetSidebar .card-deck .card .card-body {
  position: relative;
  padding: 5px 10px;
}

#targetSidebar .card-deck .card-title {
  font-size: 11px;
  line-height: 14px;
  margin-bottom: 0;
}

#targetSidebar .card-deck .card button {
  position: absolute;
  display: none;
  top: -67px;
  left: 41px;
  height: 24px;
  border: none;
  background-color: white;
  padding: 0;
}

#targetSidebar .card-deck .card svg {
  font-size: 30px;
  color: #d70070;
  margin-top: -2px;
}

#targetSidebar .card-deck .card.selected {
  border: solid 1px #4242e2;
  outline: 1px solid #1616c4;
  outline-offset: -2px;
}

#targetSidebar .card-deck .card.selected button {
  display: block;
}

#targetSidebar .card-deck .card.selected svg:hover {
  color: #820143;
}

#targetSidebar .card-deck .card:last-of-type svg {
  position: static;
  display: block;
  margin: 14px auto;
  font-size: 40px;
  color: #3160b7;
}

#targetSidebar .card-deck .card:last-of-type .card-text {
  font-size: 11px;
  line-height: 14px;
  text-align: center;
}

.b-dropdown.m-md-2 {
  margin: 0.5rem !important;
}

.b-dropdown.m-md-2 .btn-outline-secondary.focus,
.b-dropdown.m-md-2 .btn-outline-secondary:focus {
  box-shadow: none;
}

#targetSidebar .card.isSample {
  cursor: pointer;
}

#targetSidebar .card.isSample:hover {
  border: solid 1px #4242e2;
  outline: 1px solid #1616c4;
  outline-offset: -2px;
  opacity: 0.5;
}

#targetSidebar .card-body {
  text-align: left;
}

#targetSidebar .card-title {
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 0;
}

#targetSidebar .card-body .projectInfo {
  color: #334aff;
}

/* SideBar Open */
.sidebarOpen {
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translate(0, -50%);
  width: 25px;
  height: 25px;
  font-size: 25px;
  padding: 0;
  color: #e12222ea;
  background-color: transparent;
  border: none;
  z-index: 100;
}

.sidebarOpen.btn-secondary:hover {
  color: #fd6363ea;
  background-color: transparent;
  border: none;
}

.sidebarOpen.btn-secondary:not(:disabled):not(.disabled).active,
.sidebarOpen.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary.focus,
.btn-secondary:focus {
  color: #e12222ea;
  background-color: transparent;
  border: none;
  box-shadow: none;
}

.sidebarOpen svg {
  vertical-align: top;
}

@media only screen and (max-width: 600px) {
  #targetSidebar .card-deck {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    margin-left: -15px;
  }

  #targetSidebar .card-deck .card {
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    margin-left: 30px;
  }
}
</style>
